
export default {
  // Navigation-related translations
  "home": "ホーム",
  "profile": "プロフィール",
  "airports": "空港",
  "inventory": "インベントリ",
  "admin": "管理者",
  "resources": "リソース",
  "develop": "現像",
  "sign_in": "ログイン",
  "sign_up": "登録",
  // "light_meter": "露出計" // Commented out to hide from navigation
};
